var genBaseStyle = function genBaseStyle(token) {
  var _ref;
  return _ref = {}, _ref['.ant-picker-dropdown .ant-picker-time-panel-column >li.ant-picker-time-panel-cell .ant-picker-time-panel-cell-inner'] = {
    borderRadius: 0
  }, _ref;
};
var timePickerStyleFn = function timePickerStyleFn(token) {
  return [genBaseStyle()];
};

export { timePickerStyleFn };
